import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { API_ENDPOINTS } from '../api/config';

const Login: React.FC = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const navigate = useNavigate();

  // Проверяем, авторизован ли пользователь
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  const validatePhone = (phone: string): boolean => {
    // Проверяем конкретный номер +7 000 000 00 00
    return phone === '+7 (000) 000-00-00';
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Форматируем номер телефона
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 11) {
      let formatted = cleaned;
      if (cleaned.length > 0) {
        formatted = `+7 (${cleaned.slice(1, 4)}`;
        if (cleaned.length > 4) {
          formatted += `) ${cleaned.slice(4, 7)}`;
          if (cleaned.length > 7) {
            formatted += `-${cleaned.slice(7, 9)}`;
            if (cleaned.length > 9) {
              formatted += `-${cleaned.slice(9, 11)}`;
            }
          }
        }
      }
      setPhone(formatted);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Проверяем номер телефона перед отправкой запроса
    if (!validatePhone(phone)) {
      setError('Вы ввели неверный номер телефона');
      return;
    }

    try {
      const response = await axios.post(API_ENDPOINTS.login, {
        phone,
        password,
      });

      if (response.status === 200 && response.data.token) {
        localStorage.setItem('token', response.data.token);
        navigate('/');
      } else {
        setError('Ошибка авторизации. Неверный ответ от сервера.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Ошибка авторизации. Проверьте телефон и пароль.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            width: '100%',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography component="h1" variant="h5" sx={{ mb: 3, color: '#2e7d32' }}>
            Вход в админ-панель
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Телефон"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="+7 (___) ___-__-__"
              error={!!phoneError}
              helperText={phoneError}
              sx={{ mb: 2 }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Пароль"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
            />
            {error && (
              <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: '#2e7d32',
                '&:hover': {
                  backgroundColor: '#1b5e20',
                },
              }}
            >
              Войти
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login; 